module.exports = __webpack_public_path__ + "media/src/images/favicon/favicon-8ac8bbf5a86cb5e44aa4fbcb998e00f0.ico";